import { WorkspacePanelTypeEnum } from '@mark43/cad-api';
import { WorkspacePanelConfig } from '../types';
import { WorkspacePanel } from '../workspace-panel';

export function shouldBringExistingPanelToFront({
    dexNextEnabled,
    workspacePanelConfig,
    existingPanel,
}: {
    dexNextEnabled: boolean;
    workspacePanelConfig: WorkspacePanelConfig;
    existingPanel?: WorkspacePanel;
}) {
    if (!existingPanel) {
        return false;
    }

    if (workspacePanelConfig.workspacePanelType === 'DATA_EXCHANGE_FORM' && !dexNextEnabled) {
        return true;
    }

    const workspacePanelCategory =
        WorkspacePanelTypeEnum[workspacePanelConfig.workspacePanelType].workspacePanelCategory;

    return ['SINGLE_INSTANCE', 'SINGLE_INSTANCE_PER_WINDOW', 'ENTITY'].includes(
        workspacePanelCategory
    );
}
